import { useContext, useEffect, useState } from "react";
import { Button, Checkbox, Dropdown, Input } from "semantic-ui-react";
import { askMessage, openMessage } from "../Modal";
import api from "../context/api";
import { MaterialContext } from "../context/materialContext";
import { ProductContext } from "../context/productContext";

import { SettingsContext } from "../context";
import AccordionItem from "./AccordionItem";

function ProductPartPage() {
  const {
    id,
    getProductPartGroups,
    getProductMaterialGroups,
    getProductParts,
  } = useContext( ProductContext );

  const { getMaterialInfoList, getMaterialInfoListByCompany } =
    useContext( MaterialContext );
  const { company,editorProductInfo,refreshMaterial,setRefreshMaterial  } = useContext( SettingsContext );
  const [materials, setMaterials] = useState( [] );
  const [productPartGroups, setProductPartGroups] = useState( [] );
  const [productMaterialGroups, setProductMaterialGroups] = useState( [] );
  const [productMaterialGroupsDD, setProductMaterialGroupsDD] = useState( [] );
  const [productParts, setProductParts] = useState( [] );
  const [renderOverriding, setRenderOverriding] = useState( false );
  let modelViewerElement;

  useEffect(() => {
  const fetchData = async () => {
    const results = await Promise.all([
      getProductPartGroups(),
      getProductMaterialGroups(),
      getProductParts(),
      company
        ? getMaterialInfoListByCompany(company.value)
        : getMaterialInfoList(),
    ]);

    setProductPartGroups(results[0]);

    const companyMaterialGroups = await getCompanyMaterialGroups(editorProductInfo.company.id);

    setProductMaterialGroups(
      [
        ...results[1],
        ...companyMaterialGroups.filter(
          (a) =>
            !a.name.startsWith("self") &&
            !results[1]?.find((r1) => r1.id == a.id)
        ),
      ].sort((a, b) => a.name.localeCompare(b.name))
    );

    setProductParts(convertProductPartsToDD(results[2]));
    setMaterials(convertProductPartsToDD(results[3]));

    setProductMaterialGroupsDD(
      convertProductPartsToDD([
        ...results[1],
        ...companyMaterialGroups.filter((a) => !a.name.startsWith("self")),
      ])
    );
  };

  fetchData();
}, []);


  const getCompanyMaterialGroups=async(id)=>{

     if (!id) return [];
    const response =await api.getMaterialGroupsByCompanyId(id,{field:[id]});  
    console.log(response.data);

    return response.data;
  }
  const filterMaterialsByMaterialGroup = ( index ) => {
    const groupIds = productPartGroups[index].groupIds;
    const fpmg = productMaterialGroups.filter( ( e ) => {
      return groupIds && groupIds.includes( e.id );
    } );

    let mats = [];
    fpmg.forEach( ( f ) => {
      let matsIn = f.materials?.map( ( m ) => {
        return {
          key: m.id,
          value: parseFloat( m.id ),
          text: m.name,
        };
      } ) || [];
      matsIn.forEach( ( e ) => {
        let findiee = mats.filter( ( e2 ) => {
          return e.key === e2.key;
        } );
        if ( !findiee || findiee.length == 0 ) mats.push( e );
      } );
    } );

    return mats.sort( ( a, b ) => a.text.localeCompare( b.text ) );
  };

  const convertProductPartsToDD = ( productParts ) => {
    return productParts.map( ( pp ) => {
      return { key: pp.id, value: pp.id, text: pp.name };
    } );
  };

  const handleChangeName = ( i, name ) => {
    setProductPartGroups(
      productPartGroups.map( ( ppg, vi ) => {
        if ( i == vi ) return { ...ppg, title: name };
        return ppg;
      } )
    );
  };

  const handleChangeDefaultMaterialCode = ( i, code ) => {
    setProductPartGroups(
      productPartGroups.map( ( ppg, vi ) => {
        if ( i == vi ) return { ...ppg, defaultMaterialCode: code };
        return ppg;
      } )
    );
  };

  const handleChangeDefaultMaterials = ( i, defaultMaterialIds ) => {
    setProductPartGroups(
      productPartGroups.map( ( ppg, vi ) => {
        if ( i == vi ) return { ...ppg, defaultMaterialIds: defaultMaterialIds };
        return ppg;
      } )
    );
  };

  const handleChangeCode = ( i, code ) => {
    setProductPartGroups(
      productPartGroups.map( ( ppg, vi ) => {
        if ( i == vi ) return { ...ppg, code: code };
        return ppg;
      } )
    );
  };

  const handleChangeMaterialGroup = ( i, groupIds ) => {
    const newppg = productPartGroups.map( ( ppg, vi ) => {
      if ( i == vi ) {
        return { ...ppg, groupIds: groupIds };
      }
      return ppg;
    } );
    setProductPartGroups( newppg );
  };

  const handleChangeProductPart = ( i, partIds ) => {
    setProductPartGroups(
      productPartGroups.map( ( ppg, vi ) => {
        if ( i == vi ) {
          return { ...ppg, partIds: partIds };
        }
        return ppg;
      } )
    );
  };

  const handleAddProductPartGroup = () => {
    setProductPartGroups( [
      ...productPartGroups,
      { title: "", code: "", invisible: false, productId: id },
    ] );
  };

  const handleChangeinVisible = ( i, value ) => {
    setProductPartGroups(
      productPartGroups.map( ( ppg, vi ) => {
        if ( i == vi ) return { ...ppg, invisible: value };
        return ppg;
      } )
    );
  };

  const getModelViewer = () => {
    if ( !modelViewerElement )
      modelViewerElement = document.getElementById( "modelViewer" );
    return modelViewerElement;
  }

  const handleDeleteProductPartGroup = ( index ) => {
    if ( !productPartGroups[index].id || productPartGroups[index].id == 0 ) {
      setProductPartGroups(
        productPartGroups.filter( ( vo, iii ) => {
          return iii != index;
        } )
      );
      return;
    }
    askMessage(
      "Product Part Silinecektir...",
      async () => {
        await api.deleteProductPartGroup( productPartGroups[index].id );
        setProductPartGroups( [...( await getProductPartGroups( true ) )] );
        openMessage( "Product Part Silindi...", true );
      },
      () => { }
    );
  };

  const handleSaveProductPartGroup = async ( index ) => {
    openMessage( "Product Part Kaydediliyor..." );
    try {
      const response =await   api.saveProductPartGroup( productPartGroups[index] );
      setProductPartGroups( [...( await getProductPartGroups( true ) )] );
      openMessage( "Product Part Kaydedildi...", true );
      if(response.status==200){
        setRefreshMaterial(refreshMaterial+1);
      }
    } catch ( e ) {
      openMessage( "Product Part Kaydedilirken hata oluştu...", true );
    }
  };

  function highlightProductPart( ppg ) {
    const names = productParts
      .filter( pp => ppg.partIds.includes( pp.value ) )
      .map( pp => pp.text );

    const modelViewer = getModelViewer();
    const { selected } = modelViewer?.selectMaterialNames( names, true );
    modelViewer?.highlight( selected, true );
  }

  function toggleHighlightRenderOrder() {
    const modelViewer = getModelViewer();
    modelViewer?.toggleHighlightRenderOrder();
    setRenderOverriding( !renderOverriding );
  }

  return (
    <AccordionItem
      header="Product Part Group"
      key={"product-part-root-accordion"}
    >
      <div
        key={"product-part-root"}
        style={{
          color: "#FFF",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "5px",
        }}
      >
        {
          productPartGroups?.length > 0 &&
          <div title="Click on HL button to highlight the selected product part">
            <Button
              className="panel-button"
              color={renderOverriding ? "green" : "red"}
              onClick={toggleHighlightRenderOrder}
              label={"Render Order Overriding: " + ( renderOverriding ? "ON" : "OFF" )}
            />
          </div>
        }
        {productPartGroups.map( ( ppg, i ) => {
          return (
            <div key={i} className="panel-group">
              <div
                key={"product-part-option-product-key-" + i}
                style={{
                  flexGrow: "1",
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                }}
              >
                <div
                  style={{ display: "flex", flexDirection: "row", gap: "2px" }}
                >
                  <div className="panel-label"> Name</div>
                  <div style={{ flexGrow: 1 }}>
                    <Input
                      key={"name-" + i}
                      type="input"
                      id={"name-" + i}
                      value={ppg.title}
                      style={{ width: "100%" }}
                      onChange={( e, o ) => {
                        handleChangeName( i, o.value );
                      }}
                    />
                  </div>
                </div>
                <div
                  style={{ display: "flex", flexDirection: "row", gap: "2px" }}
                >
                  <div className="panel-label"> Parts</div>
                  <div style={{ flexGrow: 1 }}>
                    <Dropdown
                      id={"pp-" + i}
                      key={"pp-" + i}
                      options={productParts}
                      value={ppg.partIds || []}
                      placeholder="Select Part"
                      fluid
                      floating
                      selection
                      multiple
                      onChange={( e, o ) => {
                        handleChangeProductPart( i, o.value );
                      }}
                      search
                    />
                  </div>
                </div>
                 <div
                  style={{ display: "flex", flexDirection: "row", gap: "2px" }}
                >
                  <div className="panel-label"> Code</div>
                  <div style={{ flexGrow: 1 }}>
                    <Input
                      key={"code-" + i}
                      type="input"
                      id={"code-" + i}
                      value={ppg.code|| ""}
                      style={{ width: "100%" }}
                      onChange={( e, o ) => {
                        handleChangeCode( i, o.value );
                      }}
                    />
                  </div>
                </div>
                <div
                  style={{ display: "flex", flexDirection: "row", gap: "2px" }}
                >
                  <div className="panel-label"> Material Groups</div>
                  <div style={{ flexGrow: 1 }}>
                    <Dropdown
                      id={"dm-" + i}
                      key={"dm-" + i}
                      options={productMaterialGroupsDD}
                      placeholder="Select Material Groups"
                      fluid
                      value={ppg.groupIds}
                      floating
                      multiple
                      selection
                      onChange={( e, o ) => {
                        handleChangeMaterialGroup( i, o.value );
                      }}
                      search
                    />
                  </div>
                </div>

                <div
                  style={{ display: "flex", flexDirection: "row", gap: "2px" }}
                >
                  <div className="panel-label"> Default Material</div>
                  <div style={{ flexGrow: 1 }}>
                    <Dropdown
                      id={"pmg-" + i}
                      key={"pmg-" + i}
                      options={filterMaterialsByMaterialGroup( i )}
                      placeholder="Select Material"
                      fluid
                      floating
                      selection
                      search
                      value={ppg.defaultMaterialCode}
                      onChange={( e, o ) =>
                        handleChangeDefaultMaterialCode( i, o.value )
                      }
                    />
                  </div>
                </div>

                <div
                  style={{ display: "flex", flexDirection: "row", gap: "2px" }}
                >
                  <div className="panel-label">Own Material Group</div>
                  <div style={{ flexGrow: 1 }}>
                    <Dropdown
                      id={"pmgs-" + i}
                      key={"pmgs-" + i}
                      options={materials || []}
                      placeholder="Should be empty"
                      fluid
                      floating
                      selection
                      multiple
                      search
                      value={ppg.defaultMaterialIds}
                      onChange={( e, o ) =>
                        handleChangeDefaultMaterials( i, o.value )
                      }
                    />
                  </div>
                </div>

                <div
                  style={{ display: "flex", flexDirection: "row", gap: "2px" }}
                >
                  <div className="panel-label"> Invisible</div>
                  <div
                    style={{
                      flexGrow: 1,
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <Checkbox
                      key={"aa-" + i}
                      checked={ppg.invisible}
                      onChange={( e, o ) => {
                        handleChangeinVisible( i, o.checked );
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                key={"product-part-option-action-key-" + i}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  className="panel-button"
                  key={"product-part-option-delete-key-" + i}
                  color="red"
                  onClick={( e ) => {
                    handleDeleteProductPartGroup( i );
                  }}
                >
                  x
                </Button>
                <div>
                  <Button
                    className="panel-button"
                    key={"product-part-highlight-button-" + i}
                    disabled={!ppg.partIds || ppg.partIds.length == 0}
                    color="pink"

                    onClick={() => highlightProductPart( ppg )}
                  >
                    HL
                  </Button>
                  <br />
                  <Button
                    className="panel-button"
                    key={"product-part-option-save-key-" + i}
                    positive
                    onClick={( e ) => {
                      handleSaveProductPartGroup( i );
                    }}
                  >
                    o
                  </Button>
                </div>
              </div>
            </div>
          );
        } )}
        <div
          key={"product-part-action-panel"}
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="panel-group"
        >
          <Button color="blue" onClick={handleAddProductPartGroup}>
            +
          </Button>
        </div>
      </div>
    </AccordionItem>
  );
}

export default ProductPartPage;
